<template>
  <div class="jobs-list" v-loading="loader">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="categories" @change="save"
    >
      <div
        class="jobs-li" v-for="(cat, index) in categories" :key="index"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <span>{{ cat.name ||  cat.label}}</span>
        </div>
        <router-link :to="`/dashboard/workorders/categories/create/${cat.id}`">
          <i  class="fa fa-chevron-right"></i>
        </router-link>
      </div>
    </draggable>
    <router-link :to="`/dashboard/workorders/categories/create/`" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getWorkorderCategories} from "../../../../firestore/workorder-categories";

export default {
  name: 'List',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      categories: [],
    };
  },

  mounted() {
    this.fetchJobs();
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const categories = this.categories.map((category, index) => {
        return {
          ...category,
          _data: {
            ...category._data,
            index: index,
          },
        };
      });

      this.update(categories);
    }, 1000),

    async fetchJobs() {
      this.loader = true;

      this.categories = await getWorkorderCategories(this.$store.state.project.id);

      this.loader = false;
    },
    update(works) {
      let batch = myFirestore.batch();
      works.forEach((doc) => {
        const docRef = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('workorder-categories')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
  },

  computed: {
    filteredList() {
      return this.categories.filter(unit => {
        return (unit.name || unit.label).toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/Categories/List.vue